import { Controller } from "@hotwired/stimulus"

// Customer sites that embed the self sign-up flow listen for these messages to
// size the iframe to its content, so their shape is a public contract: only
// make backwards-compatible changes, or bump VERSION.
const VERSION = 1

// Module state survives Turbo visits, which replace <body> and reconnect this
// controller without reloading the page.
let visited = false

export default class extends Controller {
  connect() {
    if (window.parent === window) return

    this.height = null
    this.observer = new ResizeObserver(() => this.#postHeight())
    this.observer.observe(document.documentElement)

    // Skip the initial load so the host page isn't scrolled to the iframe.
    if (visited || this.#arrivedFromSameOrigin()) this.#post({ type: "ccstorage:navigate" })
    visited = true
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #arrivedFromSameOrigin() {
    try {
      return new URL(document.referrer).origin === window.location.origin
    } catch {
      return false
    }
  }

  #post(message) {
    window.parent.postMessage({ ...message, version: VERSION }, "*")
  }

  // Not scrollHeight: on the root element it never reports less than the
  // iframe's current height, so the frame could grow but never shrink.
  #postHeight() {
    const height = Math.ceil(document.documentElement.getBoundingClientRect().height)
    if (height === this.height) return

    this.height = height
    this.#post({ height, type: "ccstorage:resize" })
  }
}
